import Backbone from "backbone/backbone";
import _ from "underscore/underscore";
import "baron/baron.min.js";

import BaseView from "front/components/BaseView/BaseView.js";
import BtnSide from "front/components/BtnSide/BtnSide.js";
import BtnClose from "front/components/BtnClose/BtnClose.js";

import "./ProjectSide.css";

// TODO: Доделать правку скролла в Firefox
var ProjectSide = BaseView.extend({
    el: '.ProjectSide',

    events: {
        'click .BtnSide': 'toggle',
        'click .BtnClose': 'toggle',
        'mouseenter .ProjectSide-link': 'hoverOn',
        'mouseleave .ProjectSide-list': 'hoverOff'
    },

    initialize (options) {
        _.bindAll(this, '_scrollListener')

        this.views = {}

        this.state = new Backbone.Model({
            opened: false,
            inside: false
        })

        this.data = options.data

        this.$listContainer = this.$('.ProjectSide-listContainer')
        this.$list = this.$('.ProjectSide-list')
        this.$preview = this.$('.ProjectSide-preview')
        this.$btnClose = this.$('.BtnClose')

        this.$projectSide = $('.Project-grid')

        $.Velocity.hook(this.$preview, 'display', 'none')
        $.Velocity.hook(this.$btnClose, 'display', 'none')
        $.Velocity.hook(this.$listContainer, 'display', 'none')
        $.Velocity.hook(this.$listContainer, 'opacity', '0')
        $.Velocity.hook(this.$listContainer, 'translateX', '0')

        this.btnSide = this.views.btnSide = new BtnSide()
        this.btnClose = this.views.btnClose = new BtnClose({
            el: this.$('.BtnClose')
        })

        this.scrollListener = _.throttle(this._scrollListener, 100)

        app.els.$window.on('scroll', this.scrollListener)
        this.listenTo(this.state, 'change:inside', this.toggleBtnSide)
    },

    _scrollListener() {
        let scrollTop = app.els.$window.scrollTop()

        if (scrollTop + app.els.$window.height() > this.$projectSide.offset().top + this.$projectSide.height()) {
            this.state.set('inside', false)
        } else {
            this.state.set('inside', true)
        }
    },

    hoverOn(e) {
        let img
        let id = $(e.target).data('id')
        let project = _.findWhere(this.data, {id})

        if (app.isRetina) {
            img = project.img.tn_2x
        } else {
            img = project.img.tn
        }

        this.$preview.css('background-image', `url(${img})`)
    },

    hoverOff() {
        this.$preview.css('background-image', '')
    },

    toggle() {
        if (!this.state.get('opened')) {
            this.state.set('opened', true)
            this.open()
        } else {
            this.state.set('opened', false)
            this.close()
        }
    },

    open() {
        app.els.$body.addClass('u-NoOverflow')

        app.vent.trigger('ProjectSide-isOpening')

        this.width = this.$listContainer.outerWidth()

        this.scroll = baron({
            scroller: '.ProjectSide-list'
        })

        let duration = this.btnSide.activateSide()
        this.btnClose.playIn({
            delay: duration / 2
        })

        $.Velocity.hook(this.$preview, 'display', 'block')

        $.Velocity.animate(this.$listContainer[0], {
            opacity: 1,
            translateX: '100px'
        }, {
            display: 'block',
            delay: duration / 4,
            easing: 'easeOutQuad',
            duration: 600
        })
    },

    toggleBtnSide(state) {
        if (state.get('inside')) {
            this.btnSide.$el.fadeIn(100)
        } else {
            this.btnSide.$el.fadeOut(100)
        }
    },

    close() {
        //let duration = this.btnSide.activateSide()
        //this.btnClose.playIn({
        //    delay: duration / 2
        //})

        this.btnClose.playOut()
        this.btnSide.deactivateSide()
            .then(() => {
                app.vent.trigger('ProjectSide-isClosing')

                return $.Velocity.animate(this.$listContainer[0], {
                    opacity: 0,
                    translateX: '0px'
                }, {
                    display: 'none',
                    easing: 'easeOutQuad',
                    duration: 600
                })
                    .then(() => {
                        $.Velocity.hook(this.$preview, 'display', 'none')
                        this.scroll.dispose()
                        app.els.$body.removeClass('u-NoOverflow')
                    })
            })
    }
})

export default ProjectSide


// WEBPACK FOOTER //
// ./assets/app/front/components/ProjectSide/ProjectSide.js